'use strict';

var withStyles = require('../../Styles/withStyles.js');
var MenuItem = require('../../../node_modules/@material-ui/core/esm/MenuItem/MenuItem.js');

var styles = {
  root: {
    display: 'none'
  },
  gutters: {},
  selected: {},
  dense: {}
};
var HiddenMenuItem = withStyles["default"](styles)(MenuItem["default"]);

module.exports = HiddenMenuItem;
